import { cn } from '@/lib/tailwind.utils'

/**
 * Returns the full className string for a top-level nav link.
 * Handles active state only.
 */
export const getNavLinkClassName = (isActive: boolean): string =>
  cn(isActive ? '!bg-accent text-white-foreground dark:!bg-accent-foreground dark:!text-black' : '')

/**
 * Returns the active state className for dropdown items (e.g. use-case entries).
 * No hero variant needed here since dropdowns always render on a white background.
 */
export const getActiveItemClassName = (isActive: boolean): string =>
  isActive ? 'bg-accent text-accent-foreground' : ''
